import i18n from '@/locale/index'

export default [
  {
    path: '/anti',
    name: 'anti',
    component: () => import('../../views/anti/index.vue'),
    meta: {
      title: i18n.global.t('anti.title'),
    }
  },
]